__turbopack_context__.v({
  "comboboxOption": "_app-module__nXi_Ta__comboboxOption",
  "label": "_app-module__nXi_Ta__label",
  "required": "_app-module__nXi_Ta__required",
});
